import axios from "axios";

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.baseURL = "https://bossie-app.nl/api";

// intercepting to capture errors
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let message;

    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 403:
          message = "Access Forbidden";
          break;
        case 404:
          message = "Sorry! the data you are looking for could not be found";
          break;
        default: {
          message =
            error.response && error.response.data
              ? error.response.data["message"]
              : error.message || error;
        }
      }
    } else {
      message = error?.message || "Unknown error";
    }
    return Promise.reject(message);
  }
);

class APICore {
  get = (url: string, params: any) => {
    let response;
    if (params) {
      response = axios.get(url, { params });
    } else {
      response = axios.get(url);
    }
    return response;
  };
}

export { APICore };
